<template>
  <div>
    <b-card title="Boolean Variables">
      <b-card-body>
        <div>
          A Boolean variable is a variable that can be assigned on of two values, true and false. Those to values
          can also be 1 and 0, repectively. For example, a Boolean variable 'a' maybe assigned the value 1.
        </div>

        <div class="formula">
          a = 1
        </div>

      </b-card-body>
    </b-card><p/>
    <b-card title="AND">
      <b-card-body>
        <table class="boolean-table">
          <tr>
            <td class="boolean-table">
          <b-table class="truth-table" :items="and" :fields="andFields">
            <template #head(a)="data">
              {{data.label.toLowerCase()}}
            </template>
            <template #head(b)="data">
              {{data.label.toLowerCase()}}
            </template>
            <template #head(equation)="data">
              <span v-html="data.label"/>
            </template>
          </b-table>
          </td>
          <td class="boolean-table" width="400px">
            <b-form-select v-model="anda" size="lg" class="inline formula" :options="boolean"/>
               AND 
            <b-form-select v-model="andb" size="lg" class="inline formula" :options="boolean"/>
             = <span class="formula">{{aANDb}}</span>
          </td>
        </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card title="OR">
      <b-card-body>
        <table>
          <tr>
            <td>
              <b-table class="truth-table" :items="or" :fields="orFields">
                <template #head(a)="data">
                  {{data.label.toLowerCase()}}
                </template>
                <template #head(b)="data">
                  {{data.label.toLowerCase()}}
                </template>
                <template #head(equation)="data">
                  <span v-html="data.label"/>
                </template>
              </b-table>
            </td>
            <td class="boolean-table" width="400px">
            <b-form-select v-model="ora" size="lg" class="inline formula" :options="boolean"/>
               OR 
            <b-form-select v-model="orb" size="lg" class="inline formula" :options="boolean"/>
             = <span class="formula">{{aORb}}</span>
          </td>

          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card title="NOT">
      <b-card-body>
        <table>
          <tr>
            <td>
        <b-table class="truth-table" :items="not" :fields="notFields">
          <template #head(a)="data">
            {{data.label.toLowerCase()}}
          </template>
          <template #head(equation)="data">
            <span v-html="data.label"/>
          </template>
        </b-table>
            </td>
            <td class="boolean-table" width="400px">
            NOT <b-form-select v-model="nota" size="lg" class="inline formula" :options="boolean"/>
             = <span class="formula">{{aNOT}}</span>
            </td>
          </tr>
          </table>
      </b-card-body>
    </b-card><p/>
    <b-card title="XOR">
      <b-card-body>
        <table>
          <tr>
            <td>
        <b-table class="truth-table" :items="xor" :fields="xorFields">
          <template #head(a)="data">
            {{data.label.toLowerCase()}}
          </template>
          <template #head(b)="data">
            {{data.label.toLowerCase()}}
          </template>
          <template #head(equation)="data">
            <span v-html="data.label"/>
          </template>
        </b-table>
        </td>
      <td class="boolean-table" width="400px">
            <b-form-select v-model="xora" size="lg" class="inline formula" :options="boolean"/>
               XOR 
            <b-form-select v-model="xorb" size="lg" class="inline formula" :options="boolean"/>
             = <span class="formula">{{aXORb}}</span>
          </td>

          </tr>
        </table>
        </b-card-body>
    </b-card><p/>
  </div>
</template>

<script scoped>
export default {
  name: 'boolean',
  data () {
    return {
      anda: false,
      andb: false,
      ora: false,
      orb: false,
      nota: false,
      xora: false,
      xorb: false,
      boolean: [
        {value: false, text: '0'},
        {value: true, text: '1'}
      ],
      andFields: [
        'a', 'b', {key: 'equation', label: 'a &middot; b'}
      ],
      orFields: [
        'a', 'b', {key: 'equation', label: 'a &plus; b'}
      ],
      xorFields: [
        'a', 'b', {key: 'equation', label: 'a &#8853; b'}
      ],
      notFields: [
        'a', {key: 'equation', label: 'a&acute;'}
      ],
      and: [
        {a: 0, b: 0, equation: 0},
        {a: 0, b: 1, equation: 0},
        {a: 1, b: 0, equation: 0},
        {a: 1, b: 1, equation: 1}
      ],
      or: [
        {a: 0, b: 0, equation: 0},
        {a: 0, b: 1, equation: 1},
        {a: 1, b: 0, equation: 1},
        {a: 1, b: 1, equation: 1}
      ],
      not: [
        {a: 0, equation: 1},
        {a: 1, equation: 0}
      ],
      xor: [
        {a: 0, b: 0, equation: 0},
        {a: 0, b: 1, equation: 1},
        {a: 1, b: 0, equation: 1},
        {a: 1, b: 1, equation: 0}
      ]
    }
  },
  computed: {
    aANDb: function () {
      return this.anda && this.andb ? '1' : '0'
    },
    aORb: function () {
      return this.ora || this.orb ? '1' : '0'
    },
    aNOT: function () {
      return this.nota ? '0' : '1'
    },
    aXORb: function () {
      return ((this.xora && this.xorb) || (!this.xora && !this.xorb)) ? '0' : '1'
    }
  }
}
</script>

<style scoped>
.formula {
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  max-width: 80px;
}

.truth-table {
  font-size: x-large;
  max-width: 195px;
}

.boolean-table {
  font-size: x-large;
}

.inline {
  display: inline-block;
}

th, td {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/boolean.vue